import { useAuthWrapper } from '@weareopenr/authkit';
import { NexusPermissions, isMockMode } from '../../constants';

type NexusPermission = (typeof NexusPermissions)[keyof typeof NexusPermissions];

const ALL = Object.values(NexusPermissions) as NexusPermission[];

/**
 * Mirrors the API's rule: a staff member whose token carries no nexus:* permission at all gets every permission,
 * until the staff role in WorkOS carries them. Once any nexus:* slug is present, only those apply.
 */
export const usePermissions = () => {
  const { hasPermission: hasTokenPermission } = useAuthWrapper<NexusPermission>();
  const granted = ALL.filter((slug) => hasTokenPermission(slug));
  const hasPermission = (slug: NexusPermission) =>
    isMockMode() || granted.length === 0 || granted.includes(slug);

  const canRead = hasPermission(NexusPermissions.READ);
  const canWrite = hasPermission(NexusPermissions.WRITE);
  const canBill = hasPermission(NexusPermissions.BILLING);
  const canProvision = hasPermission(NexusPermissions.PROVISION);

  return { canRead, canWrite, canBill, canProvision };
};
